import React, { useState, useEffect } from "react";
import { Container, Nav, Navbar, Button, Form } from "react-bootstrap";
import sharva from "../../assets/sharva.png";
import "./header.css";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  // Function to change navbar className on scroll
  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  // Add scroll event listener on component mount
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Navbar
        expand="lg"
        className={`bg-body-tertiary navbar-fixed ${
          scrolled ? "navbar-scrolled" : ""
        }`}
      >
        <Container>
          <Navbar.Brand href="/">
            <img src={sharva} alt="logo" />
          </Navbar.Brand>
          <Form className="d-flex head_form">
            <a href="/appoint">
              <Button className="btnbtn">Book an Appointment</Button>
              <br />
              <small>No Cost EMI available</small>
            </a>
          </Form>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="/about">About</Nav.Link>
              <div className="dropdown">
                <Nav.Link
                  data-mdb-button-init
                  data-mdb-ripple-init
                  data-mdb-dropdown-init
                  id="dropdownMenuButton"
                  data-mdb-toggle="dropdown"
                  aria-expanded="false"
                >
                  Services &raquo;
                </Nav.Link>
                <ul
                  className="dropdown-menu"
                  style={{ top: "33px", marginBottom: "20px" }}
                  aria-labelledby="dropdownMenuButton"
                >
                  <li>
                    <a className="dropdown-item" href="/drSweta/AWI">
                      Dr. Sweta Mishra &raquo;
                    </a>
                    <ul className="dropdown-menu dropdown-submenu dropdown-submenu-doctor">
                      <li>
                        <div className="dropdown-item">Surgical &raquo; </div>
                        <ul className="dropdown-menu dropdown-submenu">
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/facelift"
                              eventKey="12"
                            >
                              Face Lift
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/necklift"
                              eventKey="14"
                            >
                              Neck Lift
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/browlift"
                              eventKey="15"
                            >
                              Brow Lift
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/hair-transplant"
                              // eventKey="18"
                            >
                              Hair Transplant
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/otoplasty"
                              eventKey="18"
                            >
                              Otoplasty
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/grafting"
                              eventKey="21"
                            >
                              Facial Fat Gratting
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/eyelid"
                              eventKey="13"
                            >
                              Eyelid Surgery (BLEPHAROPLASTY)
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/chin"
                              eventKey="16"
                            >
                              Chin Surgery (MENTOPLASTY)
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/cheeks"
                              eventKey="16"
                            >
                              Cheeks Fat Removal
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/dimple"
                              eventKey="19"
                            >
                              Dimple Creation
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/earlube"
                              eventKey="20"
                            >
                              Ear Lobe Repair
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/feminization"
                              eventKey="19"
                            >
                              Facial Feminization Surgery
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <div className="dropdown-item">
                          Non - Surgical &raquo;{" "}
                        </div>
                        <ul className="dropdown-menu dropdown-submenu">
                          <li>
                            <a
                              className="dropdown-item"
                              href="/filler"
                            >
                              Dermal Fillers &raquo;
                            </a>
                            <ul className="dropdown-menu dropdown-submenu">
                              <li>
                                <a className="dropdown-item" href="/filler">
                                  Dermal Filler in Pitampura
                                </a>
                              </li>
                              <li>
                                <a className="dropdown-item" href="/treatment/dermal-filler-rohini">
                                  Dermal Filler in Rohini
                                </a>
                              </li>
                              <li>
                                <a className="dropdown-item" href="/treatment/dermal-filler-shalimar-bagh">
                                  Dermal Filler in Shalimar Bagh
                                </a>
                              </li>
                              <li>
                                <a className="dropdown-item" href="/treatment/dermal-filler-punjabi-bagh">
                                  Dermal Filler in Punjabi Bagh
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/resurfacing"
                              eventKey="7"
                            >
                              Skin Resurfacing Procedure
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/laser"
                              eventKey="7"
                            >
                              Laser Resurfacing
                            </a>
                          </li>
                                                                                                        <li>
                            <a
                              className="dropdown-item"
                              href="/acne"
                            >
                              Acne &raquo;
                            </a>
                            <ul className="dropdown-menu dropdown-submenu">
                              <li>
                                <a className="dropdown-item" href="/acne">
                                  Acne in Pitampura
                                </a>
                              </li>
                              <li>
                                <a className="dropdown-item" href="/treatment/acne-rohini">
                                  Acne in Rohini
                                </a>
                              </li>
                            </ul>
                          </li>
                                                    <li>
                            <a
                              className="dropdown-item"
                              href="/anti-ageing"
                              eventKey="7"
                            >
                              Anti Ageing
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/microneeding"
                              eventKey="7"
                            >
                              Microneeding
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/chemical-peel"
                              // eventKey="5"
                            >
                              Chemical Peels
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/regrowth"
                              eventKey="9"
                            >
                              Hair Re-Growth Treatment Therapy
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/hydrofacial"
                              eventKey="4"
                            >
                              HydraFacial
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/laser-hair-reduction"
                            >
                              Laser Hair Reduction &raquo;
                            </a>
                            <ul className="dropdown-menu dropdown-submenu">
                              <li>
                                <a className="dropdown-item" href="/laser-hair-reduction">
                                  Laser Hair Removal in Pitampura
                                </a>
                              </li>
                              <li>
                                <a className="dropdown-item" href="/treatment/laser-hair-removal-rohini">
                                  Laser Hair Removal in Rohini
                                </a>
                              </li>
                              <li>
                                <a className="dropdown-item" href="/treatment/laser-hair-removal-shalimar-bagh">
                                  Laser Hair Removal in Shalimar Bagh
                                </a>
                              </li>
                              <li>
                                <a className="dropdown-item" href="/treatment/laser-hair-removal-pitampura">
                                  Laser Hair Removal in Pitampura (Alt)
                                </a>
                              </li>
                              <li>
                                <a className="dropdown-item" href="/treatment/laser-hair-removal-punjabi-bagh">
                                  Laser Hair Removal in Punjabi Bagh
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/pigmentation"
                            >
                              Pigmentation &raquo;
                            </a>
                            <ul className="dropdown-menu dropdown-submenu">
                              <li>
                                <a className="dropdown-item" href="/drSweta/pigmentation">
                                  Pigmentation in Pitampura
                                </a>
                              </li>
                              <li>
                                <a className="dropdown-item" href="/treatment/pigmentation-rohini">
                                  Pigmentation in Rohini
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/rejuvention"
                              eventKey="8"
                            >
                              Skin Rejuvention
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/tattoo"
                              eventKey="8"
                            >
                              Tattoo Removal
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/carbon"
                              eventKey="8"
                            >
                              Carbon Laser Peel
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/thread"
                              // eventKey="8"
                            >
                              Thread Lift
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/liquid"
                              eventKey="8"
                            >
                              Liquid Facelift
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/AWI"
                              eventKey="1"
                            >
                              Anti-Wrinkle Injection
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/boosters"
                              eventKey="3"
                            >
                              Injectable skin Boosters
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/meso"
                              eventKey="6"
                            >
                              MesoTherapy
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/micro"
                              eventKey="10"
                            >
                              MicroDermadrasion
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/makeup"
                              eventKey="11"
                            >
                              Semi- Permanent Makeup
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="/drSweta/lip"
                              eventKey="17"
                            >
                              Lip Surgery
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/drgaurav/asthma">
                      Dr. Gaurav Pandey &raquo;
                    </a>
                    <ul className="dropdown-menu dropdown-submenu dropdown-submenu-doctor">
                      <li>
                        <a
                          className="dropdown-item"
                          // eventKey="1"
                          href="/asthma"
                        >
                          Asthma
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          eventKey="2"
                          href="/drgaurav/copd"
                        >
                          COPD
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          eventKey="3"
                          href="/allergy"
                        >
                          Allergies
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          eventKey="4"
                          href="/drgaurav/tb"
                        >
                          TB
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          eventKey="5"
                          href="/drgaurav/cough"
                        >
                          Cough and cold
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          eventKey="6"
                          href="/drgaurav/chest"
                        >
                          Chest infection
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          eventKey="7"
                          href="/drgaurav/snoring"
                        >
                          Snoring
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          eventKey="8"
                          href="/drgaurav/sleep"
                        >
                          Sleep disturbances
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          eventKey="9"
                          href="/drgaurav/respiratory"
                        >
                          Respiratory issues
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          eventKey="10"
                          href="/drgaurav/sinusitis"
                        >
                          Sinusitis
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          eventKey="11"
                          href="/drgaurav/eosinophilia"
                        >
                          Eosinophilia
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          eventKey="12"
                          href="/drgaurav/diabetes"
                        >
                          Diabetes
                        </a>
                      </li>
                                                                  <li>
                        <a
                          className="dropdown-item"
                          eventKey="5"
                          href="/weight-loss"
                        >
                          Weight Loss
                        </a>
                      </li>
                                                                                        <li>
                        <a
                          className="dropdown-item"
                          eventKey="5"
                          href="/glutathione"
                        >
                          Glutathione
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          eventKey="13"
                          href="/drgaurav/neuropathy"
                        >
                          Diabetic neuropathy
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/drgaurav/hypertension"
                        >
                          Hypertension{" "}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          eventKey="15"
                          href="/drgaurav/ecg"
                        >
                          ECG
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          eventKey="16"
                          href="/drgaurav/pft"
                        >
                          PFT
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          eventKey="17"
                          href="/drgaurav/sugar"
                        >
                          SUGAR PROFILE
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <Nav.Link href="/medical-tourism">Medical Tourism</Nav.Link>
              <Nav.Link href="/gallery">Gallery</Nav.Link>
              <Nav.Link href="/contact">Contact</Nav.Link>
              <Nav.Link href="/blog">Blog</Nav.Link>
              <Nav.Link href="/award">Award</Nav.Link>
            </Nav>
            <Form className="d-flex">
              <a href="/appoint">
                <Button className="btnbtn">Book an Appointment</Button>
                <br />
                <small>No Cost EMI available</small>
              </a>
            </Form>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;